import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useCallback, useEffect } from "react";
import { Modal } from "@/components/common/Modal";
import { Button } from "@/components/common/Button";
import styles from "./QuoteDeclineReasonModal.module.css";
export const QuoteDeclineReasonModal = ({ isOpen, onClose, onSubmit, isSubmitting = false, quoteNumber, }) => {
    const [reason, setReason] = useState("");
    const [error, setError] = useState(null);
    const reset = useCallback(() => {
        setReason("");
        setError(null);
    }, []);
    useEffect(() => {
        if (!isOpen)
            reset();
    }, [isOpen, reset]);
    const handleSubmit = useCallback(async (e) => {
        e.preventDefault();
        const trimmed = reason.trim();
        if (!trimmed) {
            setError("Reason is required.");
            return;
        }
        setError(null);
        await onSubmit(trimmed);
    }, [reason, onSubmit]);
    const handleClose = useCallback(() => {
        if (!isSubmitting)
            onClose();
    }, [onClose, isSubmitting]);
    if (!isOpen)
        return null;
    const title = quoteNumber
        ? `Decline Quote #${quoteNumber}`
        : "Decline Quote";
    return (_jsx(Modal, { isOpen: isOpen, onClose: handleClose, title: title, children: _jsxs("form", { onSubmit: handleSubmit, className: styles.form, children: [_jsx("label", { htmlFor: "quote-decline-reason", className: styles.label, children: "Reason for decline" }), _jsx("textarea", { id: "quote-decline-reason", className: styles.textarea, value: reason, onChange: (e) => {
                        setReason(e.target.value);
                        if (error)
                            setError(null);
                    }, placeholder: "Please provide a reason for declining this quote.", rows: 4, disabled: isSubmitting, autoFocus: true }), error && _jsx("span", { className: styles.error, children: error }), _jsxs("div", { className: styles.actions, children: [_jsx(Button, { type: "button", variant: "secondary", onClick: handleClose, disabled: isSubmitting, children: "Cancel" }), _jsx(Button, { type: "submit", loading: isSubmitting, disabled: isSubmitting, children: "Decline quote" })] })] }) }));
};
